module.exports = __webpack_public_path__ + "img/horizontal_3_4_pp12_4.782d2681.png";